export default __webpack_public_path__ + "static/media/yellowOnboardingGraphic1.e2afff42.svg";